import type { ReactNode } from 'react'
import { useRevelado } from '@/shared/hooks/useRevelado'

/**
 * Envuelve un bloque para que se revele al entrar en pantalla (A-06).
 *
 * Existe para las listas: dentro de un `map` no se puede llamar al hook,
 * así que cada tarjeta se envuelve con esto y trae su propio observador.
 */
export function Revelar({
  children,
  className = '',
  retraso = 0,
}: {
  children: ReactNode
  className?: string
  retraso?: number
}) {
  const revelado = useRevelado<HTMLDivElement>(retraso)

  return (
    <div
      ref={revelado.ref}
      className={`${revelado.className} ${className}`.trim()}
      style={revelado.style}
    >
      {children}
    </div>
  )
}

export default Revelar
